import Site from '~/@core/domain/model/site/Site';
import { SiteService } from '~/@core/infrastructure/api/services';
import IUseCase from '../../IUseCase';

export default class GetSites implements IUseCase<string, Promise<Site[]>> {
  execute(permissionName: string): Promise<Site[]> {
    return SiteService.fetchSites(permissionName);
  }
}
